import { Panel } from "@/components/atoms";
import { ExternalSupplierNavigation } from "../../../common/ExternalSupplierNavigation";
import { ExternalSupplierDetails } from "./sections/ExternalSupplierDetails";
import { ExternalSupplierHeader } from "./sections/ExternalSupplierHeader";

export const ProfilePanel = () => {
  return (
    <div className="flex gap-3">
      <ExternalSupplierNavigation />
      <Panel>
        <ExternalSupplierHeader />
        <ExternalSupplierDetails />
      </Panel>
    </div>
  );
};
